import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Select } from 'common/components';
import { maxLength, required } from 'common/form-validators';
import { ACTIVITY_SIZE, OPTIONS } from 'common/constants';
import { isDesktop, getUserPostion } from 'common/utils';
import { mapblack as MapIcon } from 'common/svg/icons';
import { trim } from 'common/normalizers';

class ScoutingFields extends PureComponent {
  notesMax = value => maxLength(value, ACTIVITY_SIZE.MAX_NOTES);
  state = {
    helpText:
      'Select a field and move the pin on the map to mark the scouting area.',
  };

  componentDidMount() {
    if (!navigator.onLine) {
      if (navigator.geolocation) {
        this.setState(
          {
            helpText:
              'Since you are offline, the current location of the device will be used to mark the scouting area',
          },
          () => {
            getUserPostion(position => {
              const { latitude, longitude } = position.coords;
              this.props.changeValue('location', `${latitude}, ${longitude}`);
            });
          }
        );
      } else {
        this.setState({
          helpText:
            "Your device is offline and your current location can't be determined. This field is currently not available.",
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location && this.props.location !== prevProps.location) {
      const location = this.props.location;
      this.props.changeValue('location', `${location.lat}, ${location.lng}`);
    }
  }

  render() {
    const { submitting, toggleFieldView } = this.props;
    const { helpText } = this.state;

    return (
      <Fragment>
        <Input
          name="location"
          disabled={submitting}
          title="GPS Coordinates"
          readOnly={true}
          validate={[required]}
          helpText={helpText}
          withButton={
            isDesktop() ? null : (
              <Button
                onClick={e => {
                  e.preventDefault();
                  toggleFieldView();
                }}
              >
                <MapIcon width={24} />
              </Button>
            )
          }
        />
        <Select
          name="insects"
          disabled={submitting}
          disablePromptOption
          title="Insects"
          options={OPTIONS.SCOUTING_OPTIONS}
        />
        <Input
          name="insectsNotes"
          disabled={submitting}
          title="Insects Observation"
          validateOnChange={true}
          validate={[this.notesMax]}
          normalizeOnBlur={trim}
        />
        <Select
          name="weeds"
          disabled={submitting}
          disablePromptOption
          title="Weeds"
          options={OPTIONS.SCOUTING_OPTIONS}
        />
        <Input
          name="weedsNotes"
          disabled={submitting}
          title="Weeds Observation"
          validateOnChange={true}
          validate={[this.notesMax]}
          normalizeOnBlur={trim}
        />
      </Fragment>
    );
  }
}

ScoutingFields.propTypes = {
  submitting: PropTypes.bool.isRequired,
  changeValue: PropTypes.func.isRequired,
  toggleFieldView: PropTypes.func.isRequired,
  location: PropTypes.object,
};
export default ScoutingFields;



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/fields/ScoutingFields.js